'use client';

import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { useState, type PropsWithChildren } from 'react';
import { signOut } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { Routes } from '@/lib/routes/routes';
import { Link } from '@/i18n/routing';
import { trackEvent } from '@/lib/amplitude';
import { AmplitudeEvents } from '@/lib/amplitude/events';

async function keycloakSessionLogOut() {
  try {
    await fetch(`/api/auth/logout`, { method: 'GET' });
  } catch (err) {
    console.error(err);
  }
}

function UserPopover(props: PropsWithChildren & { disabled?: boolean }) {
  const t = useTranslations('header');
  const [open, setOpen] = useState(false);
  const accountMenu: { link: string; name: string; event: string }[] = [
    { link: Routes.profile, name: t('profile'), event: AmplitudeEvents.MY_ACCOUNT_CLICKED },
    { link: Routes.addresses, name: t('address'), event: AmplitudeEvents.MY_ADDRESSES_CLICKED },
    { link: Routes.order, name: t('orders'), event: AmplitudeEvents.MY_ORDERS_CLICKED },
    { link: Routes.payment, name: t('payment'), event: AmplitudeEvents.MY_SAVED_CARDS_CLICKED },
    { link: Routes.joinUs, name: t('Join-us'), event: AmplitudeEvents.JOIN_US },
  ];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button disabled={props.disabled}>{props.children}</button>
      </PopoverTrigger>
      <PopoverContent className="flex w-60 flex-col space-y-6 pt-4 pb-0">
        {accountMenu.map((item, index) => (
          <Link
            onClick={() => {
              setOpen(false);
              trackEvent(AmplitudeEvents.MY_ACCOUNT_CLICKED);
            }}
            href={item.link}
            key={index}
            className="text-primary h-7 w-full border-[#ECE9FF] px-6 text-start font-medium hover:opacity-50"
          >
            {item.name}
          </Link>
        ))}

        <button
          className="border-primary-light w-full border-t px-6 py-4 text-start font-bold text-[#B63546] hover:opacity-50"
          onClick={async () => {
            await keycloakSessionLogOut().then(() => signOut({ callbackUrl: '/' }));
          }}
        >
          {t('Log-Out')}
        </button>
      </PopoverContent>
    </Popover>
  );
}

export default UserPopover;
